import { SplitFactory } from "@splitsoftware/splitio";
class Gateway {
    constructor(client, defaultAttributes) {
        this.client = client;
        this.defaultAttributes = defaultAttributes;
    }
    get(feature, attributes = {}) {
        return this.client.getTreatment(feature, Object.assign(Object.assign({}, this.defaultAttributes), attributes));
    }
    destroy() {
        return this.client.destroy();
    }
}
const createGateway = ({ accountId, key, defaults, timeout, retries, }) => {
    return new Promise((resolve, reject) => {
        const requestTimeoutBeforeReady = timeout / 1000; // split.io uses seconds
        const readyTimeout = requestTimeoutBeforeReady * retries;
        const factory = SplitFactory({
            core: {
                authorizationKey: key,
                key: accountId,
            },
            features: defaults,
            startup: {
                readyTimeout,
                requestTimeoutBeforeReady,
                retriesOnFailureBeforeReady: retries,
            },
        });
        const client = factory.client();
        const gateway = new Gateway(client, { platform: "browser" });
        client.on(client.Event.SDK_READY, () => resolve(gateway));
        client.on(client.Event.SDK_READY_TIMED_OUT, () => reject("Split initialization timed out"));
    });
};
export default createGateway;
